import React from 'react';
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import { FormInputCheckbox, FormInputDatePicker } from "../../../ReactHookForm/FormComponents";

const HookSubFormRiskOfExclusion = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const isAtRisk = watch(sectionName + '.risk_of_exclusion_flag')

    return (
        <FieldsetContainer title='Risk Of Exclusion' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <FormInputCheckbox readOnly={readOnly} label='Is the pupil at risk of Permanent Exclusion?' sectionName={sectionName} name={'risk_of_exclusion_flag'} register={register}/>
                </BootstrapCol>
                { isAtRisk === true && <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='Date Recorded' sectionName={sectionName} name={'dmy_risk_of_exclusion_date'} control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol> }
                { isAtRisk === false && <BootstrapCol width={6}></BootstrapCol> }
            </BootstrapRow>

        </FieldsetContainer>
    )
}


export default HookSubFormRiskOfExclusion;
